<!--created @daniel.silva 2020.07.05 Updated Terms and Conditions info Component-->
<template>
    <v-snackbar v-model="enabled" bottom multi-line :timeout=0 :color=color>
        <v-layout row wrap class="caption font-weight-thin" >
            <v-flex xs12 style="font-size: 10px">
                {{text}}
            </v-flex>
            <v-flex xs6>

            </v-flex>
            <v-flex xs3>
                <v-btn color="primary" small flat @click="goTermsPolicy()">
                    {{review_text}}
                </v-btn>
            </v-flex>
            <v-flex xs3>
                <v-btn color="primary" small flat @click="acceptTermsPolicy()">
                    {{ok_text}}
                </v-btn>
            </v-flex>
        </v-layout>
    </v-snackbar>
</template>

<script>
    import {userService} from '../_services';
    import {getErrorMessage, recaptchaHelper} from "../_helpers";

    export default {
        name: "UpdatedTC",
        props: {
            enabled: Boolean
        },
        data: () => ({
            text: "Atualizámos a nossa politica de protecção de dados pessoais, termos de uso e condições gerais do programa.",
            review_text: "Rever",
            ok_text: "Ok",
            color: ""
        }),
        methods: {
            goTermsPolicy() {
                this.$router.push({name: "terms-policy"});
            },
            acceptTermsPolicy() {
                recaptchaHelper('reviewPolicyTerms', this).then((token) => {
                        let obj = {recaptcha_token: token};
                        // eslint-disable-next-line
                        userService.reviewPolicyTerms(obj).then(result => {
                                this.enabled = false;
                            },
                            error => {
                                getErrorMessage(error, 'Review Policy Terms', this);
                            });
                    },
                    error => {
                        getErrorMessage(error, 'Review Policy Terms Recaptcha', this);
                    });
            },

        }
    }
</script>

<style scoped>

</style>